module.exports = __webpack_public_path__ + "img/promptpay.ebbf74bd.png";